import { z } from "zod/v4";

export const feedbackCategorySchema = z.enum(["bug", "feature", "other"]);
export type FeedbackCategory = z.infer<typeof feedbackCategorySchema>;

export const feedbackSourceSchema = z.enum(["mobile", "club", "venue", "admin"]);
export type FeedbackSource = z.infer<typeof feedbackSourceSchema>;

export const feedbackStatusSchema = z.enum(["open", "triaged", "resolved", "dismissed"]);
export type FeedbackStatus = z.infer<typeof feedbackStatusSchema>;

export const feedbackSchema = z.object({
	id: z.string().uuid(),
	category: feedbackCategorySchema,
	body: z.string(),
	source: feedbackSourceSchema,
	status: feedbackStatusSchema,
	screenshot_url: z.string().optional(),
	created_at: z.coerce.date(),
});
export type Feedback = z.infer<typeof feedbackSchema>;

export const adminFeedbackSchema = z.object({
	id: z.string().uuid(),
	user_id: z.string(),
	user_display_name: z.string().optional(),
	user_email: z.string().optional(),
	user_avatar_url: z.string().optional(),
	category: feedbackCategorySchema,
	body: z.string(),
	source: feedbackSourceSchema,
	status: feedbackStatusSchema,
	app_version: z.string().optional(),
	os: z.string().optional(),
	device: z.string().optional(),
	page_url: z.string().optional(),
	user_agent: z.string().optional(),
	screenshot_url: z.string().optional(),
	triaged_by: z.string().optional(),
	triaged_at: z.string().optional(),
	resolution_notes: z.string().optional(),
	created_at: z.coerce.date(),
});
export type AdminFeedback = z.infer<typeof adminFeedbackSchema>;

export const createFeedbackSchema = z.object({
	category: feedbackCategorySchema,
	body: z.string().min(1).max(5000),
	source: feedbackSourceSchema,
	app_version: z.string().optional(),
	os: z.string().optional(),
	device: z.string().optional(),
	page_url: z.string().max(2048).optional(),
	user_agent: z.string().max(1024).optional(),
	screenshot_url: z.string().optional(),
});
export type CreateFeedback = z.infer<typeof createFeedbackSchema>;

export const adminUpdateFeedbackSchema = z.object({
	status: feedbackStatusSchema.optional(),
	resolution_notes: z.string().max(5000).optional(),
});
export type AdminUpdateFeedback = z.infer<typeof adminUpdateFeedbackSchema>;

export const feedbackScreenshotResponseSchema = z.object({
	url: z.string(),
});
export type FeedbackScreenshotResponse = z.infer<typeof feedbackScreenshotResponseSchema>;

export type AdminFeedbackFilters = {
	status?: FeedbackStatus;
	category?: FeedbackCategory;
	source?: FeedbackSource;
	q?: string;
	limit?: number;
	offset?: number;
};
